/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give both fractions a common denominator, add the numerators, then reduce. This tool does all three steps for you.`)
};

const es_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dale a ambas fracciones un denominador común, suma los numeradores y luego simplifica. Esta herramienta hace los tres pasos por ti.`)
};

const de_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bringe beide Brüche auf einen gemeinsamen Nenner, addiere die Zähler und kürze anschließend. Dieses Tool übernimmt alle drei Schritte für dich.`)
};

const nl_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geef beide breuken dezelfde noemer, tel de tellers op en vereenvoudig daarna. Deze tool doet alle drie de stappen voor je.`)
};

const fr_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnez aux deux fractions un dénominateur commun, additionnez les numérateurs, puis simplifiez. Cet outil effectue les trois étapes pour vous.`)
};

const it_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dai a entrambe le frazioni un denominatore comune, somma i numeratori, poi riduci. Questo strumento esegue tutti e tre i passaggi per te.`)
};

const pt_br2_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coloque as duas frações no mesmo denominador, some os numeradores e depois simplifique. Esta ferramenta faz as três etapas por você.`)
};

const pt_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dê às duas frações um denominador comum, some os numeradores e depois simplifique. Esta ferramenta faz os três passos por si.`)
};

const ja_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`両方の分数を同じ分母に揃え、分子を足し合わせてから約分します。このツールはこの3つの手順をすべて自動で行います。`)
};

const zh_fr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将两个分数化为相同分母，分子相加，再化简。本工具会为你完成全部三个步骤。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq_a1", locale)
	if (locale === "en") return en_fr_faq_a1(inputs)
	if (locale === "es") return es_fr_faq_a1(inputs)
	if (locale === "de") return de_fr_faq_a1(inputs)
	if (locale === "nl") return nl_fr_faq_a1(inputs)
	if (locale === "fr") return fr_fr_faq_a1(inputs)
	if (locale === "it") return it_fr_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq_a1(inputs)
	if (locale === "pt") return pt_fr_faq_a1(inputs)
	if (locale === "ja") return ja_fr_faq_a1(inputs)
	return zh_fr_faq_a1(inputs)
};